import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
    AlertCircle,
    CreditCard,
    Clock,
    PauseCircle,
    CalendarClock,
    X,
} from "lucide-react";

const DISMISS_KEY = "subscription_alert_dismissed";

const STATUS_CONFIG = {
    CANCELED: {
        icon: AlertCircle,
        color: "bg-red-50 text-red-800",
        messageKey: "common.subscriptionAlert.canceled",
    },
    PAST_DUE: {
        icon: CreditCard,
        color: "bg-amber-500 text-white",
        messageKey: "common.subscriptionAlert.pastDue",
    },
    UNPAID: {
        icon: CreditCard,
        color: "bg-amber-500 text-white",
        messageKey: "common.subscriptionAlert.unpaid",
    },
    INCOMPLETE: {
        icon: Clock,
        color: "bg-yellow-500 text-black",
        messageKey: "common.subscriptionAlert.incomplete",
    },
    INCOMPLETE_EXPIRED: {
        icon: Clock,
        color: "bg-yellow-500 text-black",
        messageKey: "common.subscriptionAlert.incompleteExpired",
    },
    PAUSED: {
        icon: PauseCircle,
        color: "bg-blue-500 text-white",
        messageKey: "common.subscriptionAlert.paused",
    },
    ENDING_SOON: {
        icon: CalendarClock,
        color: "bg-gray-500 text-white",
        messageKey: "common.subscriptionAlert.endingSoon",
    },
};

export default function SubscriptionAlertBanner() {
    const { user, subscriptionAlert } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem(DISMISS_KEY) === "true"
    );

    if (dismissed || !user) return null;

    const alertStatus = subscriptionAlert?.status || null;
    if (!alertStatus) return null;

    const config = STATUS_CONFIG[alertStatus];
    const Icon = config.icon;

    const handleDismiss = () => {
        sessionStorage.setItem(DISMISS_KEY, "true");
        setDismissed(true);
    };

    return (
        <div
            className={`${config.color} flex items-center justify-center gap-2 px-4 py-2 text-sm relative`}
        >
            <Icon className="h-4 w-4 shrink-0" />
            <span>{t(config.messageKey)}</span>
            <button
                onClick={() => navigate("/billing")}
                className="underline font-medium ml-1 hover:opacity-80"
            >
                {t("common.subscriptionAlert.goToBilling")}
            </button>
            <button
                onClick={handleDismiss}
                className="absolute right-2 p-1 hover:opacity-70"
                aria-label={t("common.close")}
            >
                <X className="h-4 w-4" />
            </button>
        </div>
    );
}
